
import { cloneDeep } from '@/lib';
import debounce from 'lodash/debounce';
import { Input } from 'ant-design-vue';
import {
  defineComponent, inject, ref, toRaw,
} from 'vue';

export default defineComponent({
  components: {
    aTextArea: Input.TextArea,
  },
  props: {
    /** 所有选项 */
    pMetas: {
      type: Array,
      default: () => ([]),
    },
    /** 正确选项 */
    pAnswer: {
      type: String,
      default: () => '',
    },
    /** 学生答案 */
    stuAnswer: {
      type: String,
      default: '',
    },
  },
  emits: ['onStuAnswer'],
  setup(props, { emit }) {
    const jobView = inject('jobView');
    // console.log(props.stuAnswer, 'stuAnswer');
    const todoStu = ref(props.stuAnswer);
    const todoSave = debounce(() => {
      emit('onStuAnswer', [cloneDeep(toRaw(todoStu.value))]);
    }, 700);
    return {
      jobView,
      todoStu,
      todoSave,
    };
  },
});
